export const environment = {
  production: false,
  apiBase: '',   
  identityAuthority: 'https://T-Login.nec.lcl',
  clientId: 'feedback:admin',
  redirectUri: 'http://10.100.3.5:1040/auth/callback',
  postLogoutRedirectUri: 'http://10.100.3.5:1040/auth/logout',
  scope: 'openid profile email feedback:api',
};
